import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { Router } from '@angular/router';
import { IconoirCheck, IconoirCity, IconoirNavArrowDown } from '@ey-xd/motif-icon';
import { MotifDropdownModule, MotifIconModule } from '@ey-xd/ng-motif';
import { CompanyContext } from '@models/webapi/user-profile';
import { TranslatePipe } from '@ngx-translate/core';
import { FULL_HOME_ROUTE } from '@routes';
import { CompanyContextService, EytcAuthService } from '@services';

@Component({
  selector: 'app-companies-dropdown',
  standalone: true,
  imports: [MotifIconModule, TranslatePipe, MotifDropdownModule],
  templateUrl: './companies-dropdown.component.html',
  styleUrl: './companies-dropdown.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CompaniesDropdownComponent {
  public readonly checkIcon = IconoirCheck;
  public readonly companyIcon = IconoirCity;
  public readonly arrowDownIcon = IconoirNavArrowDown;

  readonly #authService = inject(EytcAuthService);
  readonly #companyContext = inject(CompanyContextService);
  readonly #router = inject(Router);

  public readonly currentCompanyId = computed(() => {
    const company = this.#companyContext.currentCompany();
    return company?.id;
  });

  public readonly currentCompanyName = computed(() => {
    const company = this.#companyContext.currentCompany();
    return company?.name;
  });

  public readonly companies = computed(() => {
    const user = this.#authService.userProfile();

    return user?.companies.map(c => c.toCompanyContext()) ?? [];
  });

  public selectCompany(company: CompanyContext): void {
    const currentId = this.currentCompanyId();
    if (!company || company.id === currentId) {
      return;
    }
    if (company) {
      this.#companyContext.currentCompany.set(company);
      void this.#router.navigate([FULL_HOME_ROUTE]);
    }
  }
}
